<template>
<Layout>
    <div class="products">
        <div v-if="saleType === 'wholesale'" class="wholesale-banner">
            <h1 style="color: red; text-align: center; font-size: 24px; font-weight: bold;">此為批發專區，下單前請洽詢客服</h1>
        </div>
        <ProductsSection :title="'所有商品'" :saleType="saleType" :subtitle="'Products'" :productType="'all'" :showLoadMoreBtn=false :showProductCollections=false />
    </div>
</Layout>
</template>

<script>
import Layout from '@/layouts/Layout.vue'
import ProductsSection from '@/components/home/ProductsSection.vue'

export default {
    name: 'Products',
    data() {
        return {
            saleType: 'retail'
        }
    },
    created() {
        this.saleType = this.$route.query.saleType || 'retail'
    },
    watch: {
        $route(to, from) {
            this.saleType = to.query.saleType || 'retail'
        }
    },
    components: {
        Layout,
        ProductsSection,
    }
}
</script> 

<style scoped>
.products {
    margin-top: 80px;
}
.wholesale-banner {
    width: 60svw;
    margin: 0 auto;
    border: 4px solid red;
    padding: 1rem 2rem;
    margin: 2rem;
}
</style>